import { articleType } from 'src/constants/helpscoutArticles';

export const useHelpScout = (article: articleType, options?: {type: 'modal'}) => window.HelpscoutBeacon.triggerHelpScoutArticle(article, options);

export const useHelpScoutContactForm = () => window.HelpscoutBeacon.triggerHelpScoutScreen('contact-form');
